import { useInView } from "react-intersection-observer";

import React, { useEffect } from "react";

import ListingCard from "src/shared/components/ListingCard";

import { bgMouseGrey } from "../../assets";
import * as propTypes from "../../propTypes";
import buildRecentListingsImpressionLabel from "../../utilities/buildRecentListingsImpressionLabel";

const RecentlyViewedListing = ({ listing }) => {
  const { inView, ref } = useInView({
    triggerOnce: true,
    threshold: 0
  });

  const { inView: inView75percentage, ref: refAnalytics } = useInView({
    triggerOnce: true,
    threshold: 0.75
  });

  useEffect(() => {
    if (inView75percentage) {
      window.dataLayer.push({
        event: "custom_event",
        event_category: "recently_viewed_listings",
        event_action: "impression",
        event_label: buildRecentListingsImpressionLabel([listing])
      });
    }
  }, [inView75percentage]);

  return (
    <div ref={refAnalytics}>
      <div ref={ref}>
        <ListingCard
          area={`${listing.unitTypeLabel} in ${listing.area.name}`}
          bathrooms={listing.bathrooms}
          bedrooms={listing.bedrooms}
          id={listing.id}
          imgSrc={inView ? listing.mediumImageUri : bgMouseGrey}
          price={listing.listedPrice}
          theme="horizontalCard"
          title={listing.titleWithUnit}
          url={`${listing.url}?recently_viewed=1`}
        />
      </div>
    </div>
  );
};

RecentlyViewedListing.propTypes = {
  listing: propTypes.recentlyViewedListingProps.isRequired
};

export default RecentlyViewedListing;
